// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c1c4b843","239":"484325b7","455":"6efc244f"}[chunkId] + ".chunk.js";
};